import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SubTab from '../SubTab/SubTab';

const FutureWorkExperience2 = () => {
  const category = 'FutureWorkExperience2';
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();

  const handleSelect = (num) => {
    if (select === num) setSelect(0);
    else setSelect(num);
  };

  const movePage = (path) => {
    navigate(path);
  };

  /* ===================== inline styles (layout only) ===================== */
  const S = {
    gapTop: { marginTop: 18 },

    wrapGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: 14,
    },

    card: {
      background: '#fff',
      border: '1px solid rgba(15, 23, 42, 0.10)',
      borderRadius: 16,
      padding: '18px 18px 16px',
      boxShadow: '0 10px 22px rgba(15, 23, 42, 0.06)',
    },

    headRow: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 },

    badge: (bg, bd, color) => ({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '7px 10px',
      borderRadius: 999,
      background: bg,
      border: `1px solid ${bd}`,
      color,
      fontWeight: 900,
      fontSize: 13,
      letterSpacing: '-0.2px',
      flex: '0 0 auto',
    }),

    title: {
      fontSize: 18,
      fontWeight: 900,
      color: 'rgba(15, 23, 42, 0.95)',
      letterSpacing: '-0.3px',
      lineHeight: 1.25,
      margin: 0,
    },

    kpiRow: {
      display: 'grid',
      gridTemplateColumns: '120px 1fr',
      gap: 10,
      alignItems: 'start',
      padding: '10px 0',
      borderTop: '1px solid rgba(15, 23, 42, 0.08)',
    },

    kpiKey: {
      fontSize: 14,
      fontWeight: 900,
      color: 'rgba(15, 23, 42, 0.72)',
      letterSpacing: '-0.15px',
    },

    kpiVal: {
      fontSize: 15,
      fontWeight: 800,
      color: 'rgba(15, 23, 42, 0.92)',
      lineHeight: 1.6,
      letterSpacing: '-0.15px',
      wordBreak: 'keep-all',
    },

    ul: {
      margin: 0,
      paddingLeft: 18,
      fontSize: 15,
      fontWeight: 800,
      color: 'rgba(15, 23, 42, 0.90)',
      lineHeight: 1.7,
      letterSpacing: '-0.15px',
      wordBreak: 'keep-all',
    },

    li: { margin: '6px 0' },

    note: (bg, bd, color) => ({
      marginTop: 10,
      padding: '10px 12px',
      borderRadius: 12,
      background: bg,
      border: `1px solid ${bd}`,
      color,
      fontSize: 13,
      fontWeight: 900,
      lineHeight: 1.55,
      letterSpacing: '-0.1px',
      wordBreak: 'keep-all',
    }),

    // 최종성과용
    descP: {
      margin: 0,
      fontSize: 15,
      fontWeight: 800,
      color: 'rgba(15, 23, 42, 0.88)',
      lineHeight: 1.7,
      letterSpacing: '-0.15px',
      wordBreak: 'keep-all',
    },
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}사업분야{' > '}인재 양성 사업
            </div>
            <div className="banner_main_text">인재 양성 사업</div>
          </div>
        </div>

        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box business_field" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">인재양성사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  기업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  인재양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  창업육성사업
                </div>
              </div>
            </div>

            <div className="navi_box human" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">미래내일일경험(인턴형, 사전직무교육기관)</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  지역산업맞춤형 인력양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/koreanQuickStartProgram')}>
                  한국형 퀵스타트프로그램 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/smeResearchTalentSupport')}>
                  중소기업 연구인력 현장맞춤형 양성지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/FutureWorkExperience1')}>
                  미래내일경험(사전직무교육기관)
                </div>
                <div className="select_row" onClick={() => movePage('/business/FutureWorkExperience2')}>
                  미래내일경험(인턴형)
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sub_main_area temporary">
          <SubTab category={category} />

          {/* 🔹 공통 카드 헤더 */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">Future Work Experience</p>
              <h2 className="business-hero-title">미래내일일경험(인턴형)</h2>
              <p className="business-hero-period">사업기간 : 2026. 3. ~ 2026. 2.</p>
            </div>
          </div>

          <div className="sub_main_back">
            <div className="vision_container">
              {/* ===================== I. 사업내용 (원문 그대로, 카드로만 배치) ===================== */}
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>

              {/* 상세 카드들 */}
              <div style={{ ...S.wrapGrid, ...S.gapTop }}>
                <div style={S.card}>
                  <div style={S.headRow}>
                    <div
                      style={S.badge('rgba(10, 85, 207, 0.10)', 'rgba(10, 85, 207, 0.22)', 'rgba(8, 53, 143, 0.95)')}
                    >
                      목적
                    </div>
                    <h3 style={S.title}>사업 목적</h3>
                  </div>
                  <ul style={S.ul}>
                    <li style={S.li}>미취업 청년 대상 기업 현장 실무 경험 제공을 통한 직무 역량 강화</li>
                    <li style={S.li}>
                      청년의 노동시장 진입 촉진 및 중소·중견기업에 대한 인식 개선을 통한 인력 미스매치 해소
                    </li>
                  </ul>
                </div>

                <div style={S.card}>
                  <div style={S.headRow}>
                    <div style={S.badge('rgba(15, 23, 42, 0.06)', 'rgba(15, 23, 42, 0.10)', 'rgba(15, 23, 42, 0.82)')}>
                      대상
                    </div>
                    <h3 style={S.title}>참여 대상</h3>
                  </div>
                  <ul style={S.ul}>
                    <li style={S.li}>(청년) 만 15세 이상 ~ 34세 이하의 미취업 청년</li>
                    <li style={S.li}>※ 군필자의 경우 복무 기간에 비례하여 최고 만 39세까지 연장 적용</li>
                    <li style={S.li}>(기업) 고용보험 피보험자 수 10인 이상의 민간기업, 공공기관, NGO 등</li>
                    <li style={S.li}>※ 벤처기업, 혁신형 중소기업 등은 10인 미만이라도 예외적 참여 가능</li>
                  </ul>
                </div>

                <div style={S.card}>
                  <div style={S.headRow}>
                    <div style={S.badge('rgba(0, 164, 90, 0.10)', 'rgba(0, 164, 90, 0.18)', 'rgba(0, 120, 70, 0.95)')}>
                      내용
                    </div>
                    <h3 style={S.title}>주요 사업 내용</h3>
                  </div>
                  <ul style={S.ul}>
                    <li style={S.li}>
                      사전직무교육: 인턴십 수행 전 직무 기초 역량, 비즈니스 매너, 기업 문화 이해 등 교육 실시
                    </li>
                    <li style={S.li}>
                      인턴십 수행(8주): 실제 사업장 배치 후 주 25시간(일 5시간) 직무 수행, 기업별 전담 멘토 배치를 통한
                      실무 피드백 과제 수행 지원
                    </li>
                  </ul>
                </div>

                <div style={S.card}>
                  <div style={S.headRow}>
                    <div
                      style={S.badge('rgba(255, 180, 0, 0.10)', 'rgba(255, 180, 0, 0.22)', 'rgba(120, 80, 0, 0.95)')}
                    >
                      혜택
                    </div>
                    <h3 style={S.title}>지원 규모 및 혜택</h3>
                  </div>
                  <ul style={S.ul}>
                    <li style={S.li}>정량목표: 청년 인턴 120명 지원</li>
                    <li style={S.li}>
                      (청년) 인턴십 참여 기간 중 참여 수당 지급(주 최대 37.5만원, 월 최대 150만원 수준)
                    </li>
                    <li style={S.li}>
                      (기업) 멘토링 운영·내실화를 위한 멘토 수당(청년 1인당 월 최대 15만원), 기업지원금(청년 1인당 월
                      최대 20만원)
                    </li>
                  </ul>
                </div>
              </div>

              {/* ===================== II. 추진체계 (원본 그대로 유지) ===================== */}
              <div className="vision_title_box nonline" style={{ marginTop: 50 }}>
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">추진체계</div>
              </div>

              <div className="local_final_result_box">
                <div className="project-result-box">
                  <table className="project-result-table">
                    <thead>
                      <tr>
                        <th style={{ width: '12%' }}>구분</th>
                        <th style={{ width: '22%' }}>주체</th>
                        <th>주요 역할</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="result-strong">총괄</td>
                        <td>고용노동부</td>
                        <td>
                          <ul className="project-result-list">
                            <li>사업 기본계획 수립 및 총괄·보고</li>
                            <li>예산 확보 및 배정</li>
                            <li>사업 관리·감독 및 관련 제도 개선</li>
                          </ul>
                        </td>
                      </tr>

                      <tr>
                        <td className="result-strong">지원</td>
                        <td>대한상공회의소(통합지원센터)</td>
                        <td>
                          <ul className="project-result-list">
                            <li>사업 홍보 및 표준 가이드라인 제작</li>
                            <li>운영기관 성과 관리 및 모니터링 지원</li>
                            <li>우수 사례 발굴 및 성과 확산</li>
                          </ul>
                        </td>
                      </tr>

                      <tr>
                        <td className="result-strong">운영</td>
                        <td>운영기관(충남산학융합원)</td>
                        <td>
                          <ul className="project-result-list">
                            <li>참여 청년 및 기업 모집·선발</li>
                            <li>사전직무교육 운영(위탁)</li>
                            <li>인턴십 매칭, 운영 관리 및 지원금 지급</li>
                          </ul>
                        </td>
                      </tr>

                      <tr>
                        <td className="result-strong">실행</td>
                        <td>참여기업</td>
                        <td>
                          <ul className="project-result-list">
                            <li>8주간 인턴십 프로그램 실제 운영</li>
                            <li>전담 멘토 지정 및 실무 과제 부여</li>
                            <li>청년 직무 수행 지원 및 주기적 피드백 제공</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* ===================== III. 사업 목표 (원문 그대로, 카드로만 배치) ===================== */}
              <div className="vision_title_box nonline" style={{ marginTop: 18 }}>
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">최종 목표</div>
              </div>

              <div style={S.wrapGrid}>
                <div style={S.card}>
                  <div style={S.headRow}>
                    <div style={S.badge('rgba(0, 164, 90, 0.12)', 'rgba(0, 164, 90, 0.22)', 'rgba(0, 120, 70, 0.95)')}>
                      01
                    </div>
                    {/* ✅ 원문 그대로 */}
                    <h3 style={S.title}>청년의 직무 역량 강화</h3>
                  </div>
                  <ul style={S.ul}>
                    <li style={S.li}>
                      실무형 인재 양성: 직접적 직무 수행 기회 제공을 통해 청년의 실전 직무 역량 극대화
                    </li>
                    <li style={S.li}>
                      고용 가능성 제고: 기업 현장 경험 축적을 통한 미취업 청년의 취업 경쟁력 강화 및 노동시장 조기 진입
                      지원
                    </li>
                  </ul>
                </div>

                <div style={S.card}>
                  <div style={S.headRow}>
                    <div
                      style={S.badge('rgba(10, 85, 207, 0.10)', 'rgba(10, 85, 207, 0.22)', 'rgba(8, 53, 143, 0.95)')}
                    >
                      02
                    </div>
                    {/* ✅ 원문 그대로 */}
                    <h3 style={S.title}>인력 미스매치 해소</h3>
                  </div>
                  <ul style={S.ul}>
                    <li style={S.li}>
                      채용 연계 기반 구축: 기업은 검증된 인재를 탐색하고, 청년은 적성에 맞는 직무를 사전에 확인하여 정보
                      비대칭성 해소 및 인력 미스매치 완화
                    </li>
                    <li style={S.li}>
                      기업 인식 개선: 중소·중견기업 및 신산업 분야에 대한 일경험 기회를 제공하여 청년의 인식 변화 유도
                    </li>
                  </ul>
                </div>
              </div>

              <div style={{ height: 50 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FutureWorkExperience2;
